import { render, staticRenderFns } from "./listColumn.vue?vue&type=template&id=6fdcaa1a"
import script from "./listColumn.vue?vue&type=script&lang=js"
export * from "./listColumn.vue?vue&type=script&lang=js"
import style0 from "./listColumn.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports